// ============================================================================
// QuantumAI Shield — Stripe Frontend Config
// File: src/lib/stripeConfig.js  (React dashboard on Vercel)
//
// SECURITY:
//   - Publishable key ONLY — safe to include in frontend bundle
//   - Secret key is NEVER here — it lives in Oracle VM .env only
//   - Price IDs are display references only — server validates them server-side
// ============================================================================

// Publishable key — loaded from Vercel env var VITE_STRIPE_PUBLISHABLE_KEY
// Set this in Vercel Dashboard → Project → Settings → Environment Variables
// Never hardcode the actual key value here — env var only
// export const STRIPE_PUBLISHABLE_KEY = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY;
// if (!STRIPE_PUBLISHABLE_KEY) {
// console.error('[stripeConfig] VITE_STRIPE_PUBLISHABLE_KEY is not set in environment variables');
// }

// Plan definitions — price IDs sent to backend for validation
// Backend maintains the authoritative allowlist — these are display references
export const STRIPE_PLANS = {
    starter: {
        priceId:     'price_1Tij44PWUrTC2qAmcp6q7xfo',
        name:        'Starter',
        amount:      '$2,388',
        period:      'per year',
        monthlyEq:   '$199/mo',
        description: 'For startups getting compliant fast',
        mode:        'subscription',
    },
    professional: {
        priceId:     'price_1Tij7FPWUrTC2qAmcRXG6Tl9',
        name:        'Professional',
        amount:      '$4,188',
        period:      'per year',
        monthlyEq:   '$349/mo',
        description: 'For regulated industry deployments',
        mode:        'subscription',
    },
    enterprise: {
        priceId:     'price_1TijAnPWUrTC2qAmMxbyWwxK',
        name:        'Enterprise',
        amount:      '$15,588',
        period:      'per year',
        monthlyEq:   '$1,299/mo',
        description: 'For Fortune 5000 multi-system deployments',
        mode:        'subscription',
    },
    qledger: {
        priceId:     'price_1Tib6mPWUrTC2qAmBscZQ7nA',
        name:        'QLedger Sealed',
        amount:      '$5,999',
        period:      'one-time',
        monthlyEq:   null,
        description: 'Quantum-Safe Compliance Package',
        mode:        'payment',
    },
};